require('./_typed-array')('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});



//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/babel-polyfill/~/core-js/modules/es6.typed.int16-array.js
// module id = 570
// module chunks = 29